import { DateTime} from 'luxon';
import { ParkingProcessTariffInfoDTO, WeekDayFlags } from 'src/app/base/models/models.swagger.generated';
import { WeekDayFlagsHelper } from 'src/app/base/shared/utils/week-day-flags.helper';

// copied form backend
export interface IParkingTariffValidity {
  startDateTime: DateTime;
  endDateTime: DateTime;
  tariff: ParkingProcessTariffInfoDTO;
  isFallbackTariff: boolean;
}

export class ParkingTariffValidity {
  public startDateTime: DateTime;
  public endDateTime: DateTime;
  public tariff: ParkingProcessTariffInfoDTO;
  public isFallbackTariff: boolean;

  constructor(tariffValidity: IParkingTariffValidity) {
    this.startDateTime = tariffValidity?.startDateTime;
    this.endDateTime = tariffValidity?.endDateTime;
    this.tariff = tariffValidity?.tariff;
    this.isFallbackTariff = tariffValidity?.isFallbackTariff;
  }

  public getWeekDayFlagsOfValidity(): WeekDayFlags {
    let weekDayFlags: WeekDayFlags = 0 as WeekDayFlags;
    let date = this.startDateTime;
    for (let i = 0; i < 7; i++) {
      if (date.startOf('day') > this.endDateTime) {
        break;
      }
      // eslint-disable-next-line no-bitwise
      weekDayFlags |= WeekDayFlagsHelper.luxonWeekdayToFlag(date.weekday);
      date = date.plus({days: 1});
    }
    return weekDayFlags;
  }
}
